// src/components/NotificationSystem.jsx
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { removeNotification } from 'store/slices/uiSlice';
import { selectNotifications } from 'store/selectors/uiSelectors';

// ==============================|| NOTIFICATION SYSTEM ||============================== //

const NotificationSystem = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);

  // Auto-remove notifications after 5 seconds
  useEffect(() => {
    notifications.forEach((notification) => {
      if (notification.autoRemove !== false) {
        const timer = setTimeout(() => {
          dispatch(removeNotification(notification.id));
        }, 5000);

        return () => clearTimeout(timer);
      }
    });
  }, [notifications, dispatch]);

  // Get toast variant based on notification type
  const getToastVariant = (type) => {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
      case 'danger':
        return 'danger';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'secondary';
    }
  };

  // Get icon based on notification type
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
      case 'danger':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '📢';
    }
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      {notifications.map((notification) => (
        <Toast
          key={notification.id}
          show={true}
          onClose={() => dispatch(removeNotification(notification.id))}
          bg={getToastVariant(notification.type)}
          autohide={notification.autoRemove !== false}
          delay={5000}
        >
          <Toast.Header closeButton={true}>
            <span className="me-2">{getIcon(notification.type)}</span>
            <strong className="me-auto">{notification.title}</strong>
            <small className="text-muted">{new Date(notification.timestamp).toLocaleTimeString()}</small>
          </Toast.Header>
          <Toast.Body className={notification.type === 'warning' ? 'text-dark' : 'text-white'}>{notification.message}</Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
};

export default NotificationSystem;
